module.exports = __webpack_public_path__ + "static/img/11areaB_05.a6396a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/11areaB_05.png
// module id = 1094
// module chunks = 1